/** @file useImageUrls: data URLs for a list of images, filled in once encoded (empty strings until then). */
import type { Image } from '@zilo/pose3d-image-io/types/image';
import { useEffect, useState } from 'react';
import { imageDataUrl } from '../imageDataUrl';

/** One data URL per image of `images` (same order); a new list (by identity) re-encodes, a stale result is dropped. */
export function useImageUrls(images: readonly Image[]): string[] {
  const [urls, setUrls] = useState<{ of: readonly Image[]; urls: string[] } | null>(null);
  useEffect(() => {
    let live = true;
    void Promise.all(images.map((img) => imageDataUrl(img))).then((made) => { if (live) setUrls({ of: images, urls: made }); });
    return () => { live = false; };
  }, [images]);
  return urls?.of === images ? urls.urls : images.map(() => '');
}
